export const asArray = <T>(value: T | T[] | undefined | null): T[] =>
  value !== undefined && value !== null
    ? Array.isArray(value)
      ? value
      : [value]
    : [];
